'use strict';Object.defineProperty(exports,"__esModule",{value:true});var _Radio=require('./Radio.web');var _Radio2=_interopRequireDefault(_Radio);
var _RadioItem=require('./RadioItem.web');var _RadioItem2=_interopRequireDefault(_RadioItem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}
_Radio2["default"].RadioItem=_RadioItem2["default"];exports["default"]=_Radio2["default"];module.exports=exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/radio/index.web.js
// module id = 410
// module chunks = 0